import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const Loading = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='loading' />
      </Flow.StepList>
    </Flow>
  );
};
